import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 获取当前用户信息
 * @param vCom Vue组件
 */
const GetCurrentUserData = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/user").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 发送手机验证码
 * @param vCom Vue组件
 * @param phone 手机号
 */
const PostPhoneCode = (vCom: any, phone: number): Promise<any> => {
    return new Promise((resolve, reject) => {
        const params: any = {
            手机号: phone
        };
        axios.post("api/user/phonecode", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 改变手机号
 * @param vCom Vue组件
 * @param params 参数
 */
const PostChangePhone = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/user/phone", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 改变密码
 * @param vCom Vue组件
 * @param params 参数
 */
const PostChangePassword = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/user/password", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


export { GetCurrentUserData, PostPhoneCode, PostChangePhone, PostChangePassword };
